import * as LDClient from "launchdarkly-js-client-sdk";
import config from "../resources/config";
import scriptLoader from "react-async-script-loader";
import { Root } from "./containers/Root";
import React from "react";

function getRootComponentWithGoogleMaps(
  googleMapKey: string,
  Root: React.ReactNode
): typeof React.Component {
  const googleScriptUrl = `https://maps.googleapis.com/maps/api/js?key=${googleMapKey}`;
  return scriptLoader([googleScriptUrl])(Root);
}

function initializeLDClient() {
  return new Promise((resolve, reject) => {
    const hashPagineta = window.location.href;

    const user = {
      key: hashPagineta,
      custom: {
        site: "pagineta"
      }
    };
    if (config.launchDarklyKey) {
      const LDClientInstance = LDClient.initialize(
        config.launchDarklyKey,
        user
      );
      LDClientInstance.on("ready", () => resolve(LDClientInstance));
    } else {
      const error = new Error("launchDarklyKey is invalid");
      reject(error);
    }
  });
}

export function initializeApplication() {
  return initializeLDClient().then((LDClient: any) => {
    const defaultMapProvider = {
      name: "google",
      public_key: config.googleApiKey
    };

    // Pagineta only works with google map key
    const mapProvider = LDClient.variation("map-provider", defaultMapProvider);
    const googleMapKey = mapProvider.public_key;
    const RootComponentWithGoogleMaps = getRootComponentWithGoogleMaps(
      googleMapKey,
      Root
    );
    return RootComponentWithGoogleMaps;
  });
}
